module.exports = __webpack_public_path__ + "static/media/garyBorn.105e1a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/garyBorn.jpg
// module id = 1567
// module chunks = 1